import { __awaiter, __generator } from 'tslib';
import React__default from 'react';
import { thumbnailGenerationServiceConfigurationSelector, serializeComplexeParamsForRecoil, getSignaturesSelector } from '@keepeek/commons';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { generateResizedImagesFromImageServiceSelector } from '../../providers/poi/selectors.js';
import { withSuspense } from '../../withSuspense/index.js';
import CardImageLoading from '../CardImageLoading/index.js';
import DummyCard from '../DummyCard/index.js';
import { useResizeImageFromService } from '../hooks.js';
import ThumbnailTemplateActions from '../ThumbnailTemplateActions/index.js';

var Card = function Card(_a) {
    var _this = this;
    var element = _a.element, _b = _a.enabledActions, enabledActions = _b === void 0 ? ["copy", "open", "download", "update", "delete", "duplicate"] : _b, onInsert = _a.onInsert, onDelete = _a.onDelete, onUpdate = _a.onUpdate, onDuplicate = _a.onDuplicate, poi = _a.poi, thumbnailTemplate = _a.thumbnailTemplate, sx = _a.sx, KIcon = _a.KIcon, addExtensionAtEnd = _a.addExtensionAtEnd, index = _a.index;
    var t = useTranslation("refront-components").t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var techProThumbnailGeneration = useRecoilValue(thumbnailGenerationServiceConfigurationSelector);
    var generateResizedImagesFromImageService = useRecoilValue(generateResizedImagesFromImageServiceSelector(serializeComplexeParamsForRecoil({
        element: element,
        addExtensionAtEnd: addExtensionAtEnd,
        x: poi.x,
        y: poi.y
    })));
    var signedResizedImages = useRecoilValue(getSignaturesSelector({
        serviceId: "images",
        baseUrl: techProThumbnailGeneration.url,
        resourcePaths: generateResizedImagesFromImageService
    }));
    var getResizedImageFromService = useResizeImageFromService();
    var handleDownload = function () { return __awaiter(_this, void 0, void 0, function () {
        var resizedImage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getResizedImageFromService({
                            element: element || undefined,
                            poi: poi,
                            resizeHeight: thumbnailTemplate.height,
                            resizeWidth: thumbnailTemplate.width,
                            resizeFormat: thumbnailTemplate.format,
                            downloadPrefixName: thumbnailTemplate.label,
                            addExtensionAtEnd: addExtensionAtEnd
                        })];
                case 1:
                    resizedImage = _a.sent();
                    window.open(resizedImage);
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    enqueueSnackbar(t("components.kf-thumbnail-generator.preview.download-link.error"), {
                        variant: "error"
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement(DummyCard, { testId: "dummyCardId", sx: sx, image: signedResizedImages[index], name: thumbnailTemplate.label, format: thumbnailTemplate.format, iconName: thumbnailTemplate.icon, width: thumbnailTemplate.width, height: thumbnailTemplate.height, KIcon: KIcon, shared: thumbnailTemplate.shared, actionsComponent: React__default.createElement(ThumbnailTemplateActions, { permission: thumbnailTemplate.permission, enabledActions: enabledActions, onInsert: onInsert, KIcon: KIcon, onDelete: onDelete, onUpdate: onUpdate, onDuplicate: onDuplicate, onDownload: handleDownload, element: element, image: signedResizedImages[index] }) }));
};
var Card$1 = withSuspense(Card, {
    LoadingComponent: CardImageLoading
});

export { Card$1 as default };
//# sourceMappingURL=index.js.map
